module.exports = __webpack_public_path__ + "img/0x5fc48c2375eb7c4f12eb182b23e1c12b164e4e9a.803d225c.png";